import { useEffect, useState } from 'react';
import './Home.css';
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Productcard from '../../Components/Productcard/Productcard';
import Collectioncard from '../../Components/Collectioncard/Collectioncard';
import { Link } from 'react-router-dom';
import Cartstrip from '../../Components/Cartstrip/Cartstrip';
import Slider from 'react-slick';

// const CustomPrevArrow = (props) => {
//     const { className, style, onClick } = props;
//     return (
//         <div
//             className={`${className} custom-arrow custom-prev-arrow`}
//             style={{ ...style, display: "block" }}
//             onClick={onClick}
//         />
//     );
// };

// const CustomNextArrow = (props) => {
//     const { className, style, onClick } = props;
//     return (
//         <div
//             className={`${className} custom-arrow custom-next-arrow`}
//             style={{ ...style, display: "block" }}
//             onClick={onClick}
//         />
//     );
// };

function Home() {

    // const [cattabs, setCattabs] = useState(1);
    // const [sellertab, setSellertab] = useState(1);
    const [prodata, setProdata] = useState([]);
    const [mugs, setMugs] = useState([]);
    const [homedecors, setHomedecors] = useState([]);
    const [walldecor, setWalldecor] = useState([]);
    const [hiddencat, setHiddencat] = useState('d-none');

    useEffect(()=> window.scrollTo(0, 0), []);
    
    const herocaro = {
        infinite: true,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        slidesToScroll: 1,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    }
    
    useEffect(()=> {
        fetch(`https://pentadeco.in/api/bestsellers`).then(res => res.json()).then(data => {
            if(data.success){
                setProdata(data.products);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/white mug`).then(res => res.json()).then(data => {
            if(data.success){
                setMugs(data.products);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/mouse pad`).then(res => res.json()).then(data => {
            if(data.success){
                setHomedecors(data.products);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> {
        fetch(`https://pentadeco.in/api/products/1/4/wall decor`).then(res => res.json()).then(data => {
            if(data.success){
                setWalldecor(data.products);
            }else{
                console.log(data);
            }
        }).catch(err => console.log('error occured while getting all the pros ', err));
    }, []);

    useEffect(()=> console.log(prodata), [prodata]);

    // const splitFunc = (str)=> {
    //     const imgFst = str.split(',');
    //     console.log(imgFst)
    //     return imgFst;
    // }

    return (
        <div className='main-home overflow-hidden'>
            <div className="container-fluid desk-herooo mx-auto bg-brand-light m-0 p-0 pb-5">
                <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0 py-4">
                            <div className="col-md-12">
                                <p className="mb-0 text-dark text-muted fs-sm body-font-semibold text-center">SALE! UP TO 50% OFF!</p>
                                <h2 className="mb-0 fs-1 text-dark body-font-semibold lh-sm text-center">Stylish & Premium Home <br />& Kitchen Decor Accessories</h2>
                                {/* <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button> */}
                                <div className="d-flex justify-content-center flex-wrap p-0 mt-3">
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="White Mug" img="/assets/categories/IMG_3112.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Mouse Pad" img="/assets/categories/547A9131.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Wall Decor" img="/assets/categories/IMG_3067.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Copper Bottle" img="/assets/categories/copper-bottle.jpeg" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Tote Bag" img="/assets/categories/547a8909.JPG" />
                                    </div>
                                    <div className="collection-card-wrapper p-2 mb-2">
                                        <Collectioncard name="Money Bank" img="/assets/categories/547A4247.JPG" />
                                    </div>
                                    {
                                        hiddencat === 'd-none' && (
                                            <div className="w-max-content cursor-pointer mx-auto mt-2" onClick={() => setHiddencat('d-flex')}>
                                                <p className="mb-0 text-brand-primary body-font-bold text-center mx-auto w-max-content cursor-pointer">show more</p>
                                                <p className="mb-0 text-center text-brand-primary mt-2 mx-auto w-max-content cursor-pointer"><i className="fi fi-ss-chevron-double-down"></i></p>
                                            </div>
                                        )
                                    }
                                    <div className={`${hiddencat} justify-content-center flex-wrap`}>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Frosted Glass Jar" img="/assets/categories/547A4868.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Capsule Mug" img="/assets/categories/547A4158.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Inside Colour Mug" img="/assets/categories/547A9024.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Magic Mug" img="/assets/categories/547A4904.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Bag Tag" img="/assets/categories/547A4378.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Coasters" img="/assets/categories/547A4304.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Coke Bottle" img="/assets/categories/547A4253.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Sipper Water Bottle (600ml)" img="/assets/categories/547A9113.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Sipper Water Bottle (750ml)" img="/assets/categories/547A9068.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Sports Water Bottle" img="/assets/categories/547A4555.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Set of 2 Cups" img="/assets/categories/547A4297.JPG" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Keyboard & laptop Mat" img="/assets/categories/new-cat.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Frosted Mug" img="/assets/categories/frosted-mug.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Frosted Tumbler" img="/assets/categories/frosted-tumbler.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Mobile Stand" img="/assets/categories/mobile-stand.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Steel Mug" img="/assets/categories/steel-mug.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Tumblers" img="/assets/categories/tumblers.jpeg" />
                                        </div>
                                        <div className="collection-card-wrapper p-2 mb-2">
                                            <Collectioncard name="Water Bottles" img="/assets/categories/water-bottles.jpeg" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-7">
                                <Slider {...herocaro} >
                                    <img src="/assets/new-hero-1.png" alt="" className="img-fluid"/>
                                    <img src="/assets/new-hero-2.png" alt="" className="img-fluid"/>
                                    <img src="/assets/new-hero-3.png" alt="" className="img-fluid"/>
                                </Slider>
                            </div> */}
                        </div>
                    </div>
                {/* <Slider {...herocaro}>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Home & Decor <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6">
                                <img src="/assets/new-hero-img.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Afficient Kitchen <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6">
                                <img src="/assets/hero-kitchen1.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                    <div className="slider-wrap">
                        <div className="main-hero-div row align-items-center container mx-auto p-0 m-0">
                            <div className="col-md-6">
                                <p className="mb-0 text-dark text-muted body-font-semibold">SALE! UP TO 50% OFF!</p>
                                <p className="mb-0 hero-text text-dark body-font-semibold lh-sm">Best Cleaning <br />Accessories</p>
                                <button className="btn btn-dark px-4 py-2 body-font-semibold rounded-3 mt-4">Shop Now</button>
                            </div>
                            <div className="col-md-6 p-0">
                                <img src="/assets/hero-cleaning1.png" alt="" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>
                </Slider> */}
            </div>
            
            {/* <div className="container">
                <div className="whats-new-card-wrap mt-5 pb-3">
                    <h2 className="text-center mb-4 fs-2 head-font-bold">EXPLORE CATEGORIES</h2>
                    <div className='row justify-content-center p-0 m-0 px-2'>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="home decor" img="/assets/cat-home.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="kitchen decor" img="/assets/cat-kitchen.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="drinkware" img="/assets/cat-mugs.png" />
                        </div>
                        <div className="col-md-2 col-3 p-1">
                            <Collectioncard name="accessory" img="/assets/cat-personal.png" />
                        </div>
                    </div>
                </div>
            </div> */}
            
            {/* <div className="container-fluid p-0 pb-5 mt-5 pt-2">
                <div className="banner-wrap desk-banner px-3">
                    <Slider {...herocaro}>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://cdn.shopify.com/s/files/1/0550/8890/6475/files/home___decor_2_1.jpg?v=1634120765" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                    </Slider>
                </div>
                <div className="banner-wrap mob-banner">
                    <Slider {...herocaro}>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                        <Link to="/product" className='nav-link'>
                            <img src="https://d39vol41m7feya.cloudfront.net/1655709855-2.jpg" alt="" className="img-fluid w-100 rounded-brand" />
                        </Link>
                    </Slider>
                </div>
            </div> */}
            {/* <div className="container d-none">
                <div className="whats-new-div mt-5 pt-3">
                    <h2 className="text-center fs-2 body-font-bold">What's New</h2>
                    <div className="cat-tabs-wrap desk-tabs mt-4">
                        <div className="cat-tabs bg-light d-flex align-items-center rounded-brand w-max-content mx-auto p-2">
                            <div className="tab-back bg-white shadow-sm rounded-brand-sm" style={{ left: cattabs === 1 ? 10 : 100 * (cattabs - 1) }}></div>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 1 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(1)}>ALL</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 2 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(2)}>HOME</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 3 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(3)}>KITCHEN</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 4 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(4)}>KIDS</p>
                            <p className={`mb-0 me-0 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 5 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(5)}>BATHROOM</p>
                        </div>
                    </div>
                    <div className="cat-tabs-wrap mob-tabs mt-4">
                        <div className="cat-tabs bg-light d-flex align-items-center rounded-brand w-max-content mx-auto p-2">
                            <div className="tab-back bg-white shadow-sm rounded-brand-sm" style={{ left: cattabs === 1 ? 10 : 100 * (cattabs - 1) }}></div>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 1 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(1)}>ALL</p>
                            <p className={`mb-0 me-3 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 2 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(2)}>HOME</p>
                            <p className={`mb-0 me-0 px-3 py-1 body-font-semibold rounded-brand-sm cursor-pointer ${cattabs === 3 ? 'bg-dark shadow-sm text-white' : 'text-muted'}`} onClick={() => setCattabs(3)}>KIDS</p>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="scrolling-container">
                <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
                <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
            </div> */}

            <div className="container-fluid">
                <div className="whats-new-card-wrap mt-5 pb-5">
                    <h2 className="text-center mb-4 fs-2 head-font-bold text-brand-secondary text-uppercase">Best seller</h2>
                    <div className="new-cards row px-2">
                        {
                            prodata.length > 0 && (
                                prodata.slice(0, 4).map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                    <div className="mx-auto W-100 text-center mt-3 cursor-pointer">
                        <Link to="/product" className="btn btn-outline-dark fs-esm mx-auto body-font-semibold px-3 rounded-pill">VIEW ALL</Link>
                        {/* <Link to={'/product'} className="boton-elegante fs-esm py-1 nav-link w-max-content mx-auto">SEE MORE</Link> */}
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <img src="/assets/banner/banner-capsulemug.jpg" alt="" className="img-fluid w-100" />
            </div>

            <div className="container-fluid">
                <div className="whats-new-card-wrap mt-5 pb-5">
                    <h2 className="text-center mb-4 fs-2 head-font-bold text-brand-secondary text-uppercase">White Mugs</h2>
                    <div className="new-cards row px-2">
                        {
                            mugs.length > 0 && (
                                mugs.map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                    <div className="mx-auto W-100 text-center mt-3 cursor-pointer">
                        <Link to="/product?category=white-mug&page=1" className="btn btn-outline-dark fs-esm mx-auto body-font-semibold px-3 rounded-pill">VIEW ALL</Link>
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <img src="/assets/banner/banner-mousepad.jpg" alt="" className="img-fluid w-100" />
            </div>

            <div className="bestseller-div mt-5">
                <div className="container-fluid">
                    <div className="whats-new-card-wrap mt-3 pb-5">
                        <h2 className="text-center mb-4 fs-2 head-font-bold text-brand-secondary text-uppercase">Mouse Pads</h2>
                        <div className="new-cards row">
                            {
                                homedecors.length > 0 && (
                                    homedecors.map((pro, ind) => (
                                        <div key={ind} className="col-md-3 col-6 p-1">
                                            <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                        </div>
                                    ))
                                )
                            }
                        </div>
                        <div className="mx-auto w-max-content mt-3">
                            <Link to="/product?category=mouse+pad&page=1" className="btn btn-outline-dark fs-esm mx-auto body-font-semibold px-3 rounded-pill">VIEW ALL</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="banner-wrap my-5">
                <div className="banner-strip"></div>
                <img src="/assets/wall-decor.jpg" alt="" className="img-fluid w-100" />
            </div>

            <div className="bestseller-div mt-5">
                <div className="container-fluid">
                    <div className="whats-new-card-wrap mt-3 pb-5">
                        <h2 className="text-center mb-4 fs-2 head-font-bold text-brand-secondary text-uppercase">Wall Decors</h2>
                        <div className="new-cards row">
                            {
                                walldecor.length > 0 && (
                                    walldecor.map((pro, ind) => (
                                        <div key={ind} className="col-md-3 col-6 p-1">
                                            <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                        </div>
                                    ))
                                )
                            }
                        </div>
                        <div className="mx-auto w-max-content mt-3">
                            <Link to="/product?category=wall+decor&page=1" className="btn btn-outline-dark fs-esm mx-auto body-font-semibold px-3 rounded-pill">VIEW ALL</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mb-5">
                <h2 className="text-center mb-4 fs-2 head-font-bold text-brand-secondary text-uppercase">Frequently Asked Questions (FAQs)</h2>
                <div className="faqs-wrapper">
                    <div className="accordion rounded-brand" id="accordionExample">

                        {/* FAQ 1 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse1"
                                    aria-expanded="true"
                                    aria-controls="collapse1"
                                >
                                    How long does shipping take?
                                </button>
                            </h2>
                            <div
                                id="collapse1"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We usually deliver within <strong>3–7 working days</strong> depending on your location. Metro cities may get faster delivery.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse2"
                                    aria-expanded="false"
                                    aria-controls="collapse2"
                                >
                                    Do you charge for shipping?
                                </button>
                            </h2>
                            <div
                                id="collapse2"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We offer <strong>free shipping on orders above ₹999</strong>. For smaller orders, a minimal delivery charge may apply.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse3"
                                    aria-expanded="false"
                                    aria-controls="collapse3"
                                >
                                    Do you offer Cash on Delivery (COD)?
                                </button>
                            </h2>
                            <div
                                id="collapse3"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Yes, COD is available across India for most pin codes.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse4"
                                    aria-expanded="false"
                                    aria-controls="collapse4"
                                >
                                    How can I track my order?
                                </button>
                            </h2>
                            <div
                                id="collapse4"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Once your order is shipped, you will receive a <strong>tracking link via email/SMS</strong>. You can track the live status of your order anytime.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse5"
                                    aria-expanded="false"
                                    aria-controls="collapse5"
                                >
                                    What is your return policy?
                                </button>
                            </h2>
                            <div
                                id="collapse5"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    You can return products within <strong>7 days of delivery</strong> if they are damaged, defective, or not as described.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 6 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse6"
                                    aria-expanded="false"
                                    aria-controls="collapse6"
                                >
                                    How safe is my payment?
                                </button>
                            </h2>
                            <div
                                id="collapse6"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    We use <strong>100% secure payment gateways</strong> with encryption to ensure a safe and smooth checkout.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 7 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse7"
                                    aria-expanded="false"
                                    aria-controls="collapse7"
                                >
                                    Do you take bulk or custom orders?
                                </button>
                            </h2>
                            <div
                                id="collapse7"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    Yes, we do accept <strong>bulk & corporate orders</strong>. For customization, kindly contact our support team.
                                </div>
                            </div>
                        </div>

                        {/* FAQ 8 */}
                        <div className="accordion-item rounded-brand mb-2 border-0">
                            <h2 className="accordion-header rounded-brand border-0">
                                <button
                                    className="accordion-button border-0 shadow-none rounded-brand collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse8"
                                    aria-expanded="false"
                                    aria-controls="collapse8"
                                >
                                    How can I reach your support team?
                                </button>
                            </h2>
                            <div
                                id="collapse8"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div className="accordion-body">
                                    You can contact us via:
                                    <br />
                                    <strong>Email:</strong> <a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a>
                                    <br />
                                    <strong>WhatsApp:</strong> +91 7738494171, +91 8433551012, +91 9273158535
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container mb-5">
                <div className="mt-5 row">
                    {/* 1️⃣ Shipping Faster */}
                    <div className="col-md-3 d-flex flex-column align-items-center p-2">
                        <i className="fi fi-rs-shipping-fast fs-1 text-brand-secondary"></i>
                        <p className="mb-0 body-font-bold text-center">Free & Fast Shipping</p>
                        <p className="mb-0 mt-1 body-font-light text-center text-muted">
                            We ensure swift and timely delivery to your doorstep, so you can enjoy your decor without delay.
                        </p>
                    </div>

                    {/* 2️⃣ High Quality Products */}
                    <div className="col-md-3 d-flex flex-column align-items-center p-2">
                        <i className="fi fi-rs-badge-check fs-1 text-brand-secondary"></i>
                        <p className="mb-0 body-font-bold text-center">Quality Products</p>
                        <p className="mb-0 mt-1 body-font-light text-center text-muted">
                            Every product is crafted with superior materials and attention to detail, guaranteeing durability and a premium finish.
                        </p>
                    </div>

                    {/* 3️⃣ Amazing Designs */}
                    <div className="col-md-3 d-flex flex-column align-items-center p-2">
                        <i className="fi fi-rs-sparkles fs-1 text-brand-secondary"></i>
                        <p className="mb-0 body-font-bold text-center">Amazing Designs</p>
                        <p className="mb-0 mt-1 body-font-light text-center text-muted">
                            Explore a unique collection of stylish, trendy, and elegant designs that uplift your living space.
                        </p>
                    </div>

                    {/* 4️⃣ Safe Checkouts */}
                    <div className="col-md-3 d-flex flex-column align-items-center p-2">
                        <i className="fi fi-rs-lock fs-1 text-brand-secondary"></i>
                        <p className="mb-0 body-font-bold text-center">Safe Checkouts</p>
                        <p className="mb-0 mt-1 body-font-light text-center text-muted">
                            Shop with confidence with our fully secure and hassle-free online payment options.
                        </p>
                    </div>
                </div>
            </div>

            <Cartstrip/>

        </div>
    )
}

export default Home;